import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import ADJUST_ICON from '@tencent/docs-design-resources/icon/desktop/svg/zoomin_light_24.svg';

export const config = {
    id: ActionType.ADJUST_SLIDE,
    icon: ADJUST_ICON,
    content: i18n.t('缩放'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.content,
        style: {
        },
    },
];

const menuStyle = {
    minWidth: 68,
};

export const ADJUST_SLIDE_CONFIG: MenuConfig[] = [
    { name: ActionType.ADJUST_SLIDE_50, content: '50%', style: menuStyle, tooltip: '50%'  },
    { name: ActionType.ADJUST_SLIDE_75, content: '75%', style: menuStyle, tooltip: '75%' },
    { name: ActionType.ADJUST_SLIDE_100, content: '100%', style: menuStyle, tooltip: '100%' },
    { name: ActionType.ADJUST_SLIDE_125, content: '125%', style: menuStyle, tooltip: '125%' },
    { name: ActionType.ADJUST_SLIDE_150, content: '150%', style: menuStyle, tooltip: '150%' },
    { name: ActionType.ADJUST_SLIDE_200, content: '200%', style: menuStyle, tooltip: '200%' },
    { name: ActionType.ADJUST_SLIDE_300, content: '300%', style: menuStyle, tooltip: '300%' },
    { name: ActionType.ADJUST_SLIDE_400, content: '400%', style: menuStyle, tooltip: '400%' },
];


export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: '',
    },
    ...ADJUST_SLIDE_CONFIG,
];
